import styled from 'styled-components';
import { MD_FONT_SIZE, PRIMARY_COLOR, SECONDARY_COLOR, SEMI_FONT_WEIGHT, SM_FONT_SIZE, WHITE_COLOR } from '../../Common/StyleElement';

export const Container = styled.div`
    flex-basis: auto;
    flex-grow: 0;
    padding: 0;
    background-color: ${WHITE_COLOR};
    width: calc(25% - 1.5rem);
    height: 300px;
    border-radius: 10px;
    box-shadow: inset 0px 0px 0px 1px #edeef4;
    position: relative;
    transition: all 0.4s ease;
    margin: 0 0.75rem 1.6rem 0.75rem;
`

export const TeamCardContainer = styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
`

export const TeamBG = styled.span`
    position: absolute;
    width: 100%;
    height: 100px;
    top: 0;
    border-radius: 10px 10px 0px 0px;
    transition: all 0.4s ease;
    background: linear-gradient(140deg, ${PRIMARY_COLOR} 0%, ${SECONDARY_COLOR});
    z-index: 1;
`

export const TeamFigure = styled.figure`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 120px;
    border-radius: 100%;
    overflow: hidden;
    z-index: 1;
    position: absolute;
    top: 40px;
    border: 3px solid ${WHITE_COLOR};
    transition: all 0.4s ease;
    box-shadow: 0px 4px 10px rgb(111 112 115 / 30%);
`

export const TeamArticle = styled.article`
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: absolute;
    transform: translateY(70px);
    transition: all 0.3s ease;
    padding: 0 1rem;
`

export const TeamArticleName = styled.p`
    font-size: ${MD_FONT_SIZE};
    color: #333;
    font-weight: 300;
    text-align: center;
`

export const TeamArticleRole = styled.p`
    font-size: ${SM_FONT_SIZE};
    font-weight: ${SEMI_FONT_WEIGHT};
    color: #CBCBCB;
    letter-spacing: 0.8px;
    margin-top: 5px;
`